import React, { useState } from 'react';
import { Form, Button, message, Typography } from 'antd';
import { MailOutlined, ArrowLeftOutlined, SendOutlined, CheckCircleOutlined } from '@ant-design/icons';
import api from '../services/api';
import './Login.css';
import './ForgotPassword.css';

const { Text } = Typography;

const fieldBox = {
  display: 'flex',
  alignItems: 'center',
  background: 'rgba(255,255,255,0.10)',
  border: '1px solid rgba(255,255,255,0.22)',
  borderRadius: '10px',
  height: '52px',
  padding: '0 14px',
  gap: '10px',
};

const nativeInput = {
  flex: 1,
  background: 'transparent',
  border: 'none',
  outline: 'none',
  color: 'white',
  fontSize: '15px',
  lineHeight: '52px',
};

const iconStyle = { color: 'rgba(255,255,255,0.45)', fontSize: '16px', flexShrink: 0 };

const CustomEmailInput = React.forwardRef(({ value, onChange, placeholder, disabled }, ref) => (
  <div style={fieldBox}>
    <MailOutlined style={iconStyle} />
    <input
      ref={ref}
      type="email"
      value={value || ''}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      style={nativeInput}
      autoComplete="email"
      className="login-native-input"
    />
  </div>
));
CustomEmailInput.displayName = 'CustomEmailInput';

const ForgotPassword = ({ onBack }) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', {
        email: values.email,
      });
      message.success('Email inviata! Controlla la tua posta.');
      setSubmitted(true);
      form.resetFields();
      
      // Auto-close after 5 seconds
      setTimeout(() => {
        if (onBack) onBack();
      }, 5000);
    } catch (error) {
      message.error(error.response?.data?.detail || 'Errore nel recupero password');
      setLoading(false);
    }
  };

  return (
    <div className="login-page forgot-password-page">
      <div className="login-bg">
        <div className="blob blob-1" />
        <div className="blob blob-2" />
        <div className="blob blob-3" />
      </div>

      <div className="login-left">
        <div className="login-brand">
          <img src="/logo_nke_login.png" alt="NKE Sterling" className="login-logo-nke" />
          <img src="/logo_app.png?v=2" alt="Arkivio QHSE" className="login-logo-app" />
          <p className="login-tagline">
            Recupero accesso sicuro<br />
            <span>Ricevi una password temporanea e rientra nella piattaforma</span>
          </p>
        </div>
        <div className="login-features">
          <div className="feature-item"><span className="feature-dot" />Invio controllato all'indirizzo registrato</div>
          <div className="feature-item"><span className="feature-dot" />Cambio password richiesto al prossimo accesso</div>
          <div className="feature-item"><span className="feature-dot" />Stesso canale email delle notifiche QHSE</div>
        </div>
      </div>

      <div className="login-right">
        <div className="login-card">
          <div className="login-card-header">
            <div className="login-icon-box">
              {submitted ? <CheckCircleOutlined /> : <MailOutlined />}
            </div>
            <h2>{submitted ? 'Controlla la posta' : 'Recupera password'}</h2>
            <Text style={{ color: 'rgba(255,255,255,0.55)', fontSize: 14 }}>
              {submitted
                ? "Se l'indirizzo esiste nel sistema, riceverai le istruzioni entro pochi minuti"
                : "Inserisci l'email associata al tuo account"}
            </Text>
          </div>

          {!submitted ? (
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              size="large"
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: 'Inserisci la tua email' },
                  { type: 'email', message: 'Email non valida' },
                ]}
              >
                <CustomEmailInput
                  placeholder="Indirizzo email"
                  disabled={loading}
                />
              </Form.Item>

              <Form.Item style={{ marginTop: 8, marginBottom: 12 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  size="large"
                  loading={loading}
                  icon={<SendOutlined />}
                  iconPosition="end"
                  style={{
                    height: '52px',
                    borderRadius: '10px',
                    background: 'linear-gradient(135deg, #1565c0, #1e88e5)',
                    border: 'none',
                    fontSize: '15px',
                    fontWeight: 600,
                    boxShadow: '0 4px 20px rgba(21,101,192,0.45)',
                  }}
                >
                  Invia istruzioni
                </Button>
              </Form.Item>

              <div style={{ textAlign: 'center' }}>
                <Button
                  type="link"
                  icon={<ArrowLeftOutlined />}
                  onClick={onBack}
                  disabled={loading}
                  style={{ color: 'rgba(255,255,255,0.45)', fontSize: 13 }}
                >
                  Torna al login
                </Button>
              </div>
            </Form>
          ) : (
            <div className="success-message">
              <p>Se l'email esiste nel sistema, riceverai una password temporanea entro pochi minuti.</p>
              <Button
                type="primary"
                onClick={onBack}
                block
                size="large"
                style={{
                  height: '52px',
                  borderRadius: '10px',
                  marginTop: 18,
                  background: 'linear-gradient(135deg, #1565c0, #1e88e5)',
                  border: 'none',
                  fontWeight: 600,
                }}
              >
                Torna al login
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
